class IntegrationsController {
  constructor(
    $rootScope,
    $scope,
    Account,
    toaster,
    Facebook,
    YouTubeUser,
    TwitterUser,
    RTMPPushChannel,
    VimeoUser,
    Broadcast,
    $q,
    $uibModal,
    FacebookUser,
    $timeout,
    $state
  ) {
    'ngInject';
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.FeatureFlags = this.account.feature_flags;
    this.$scope = $scope;
    this.Account = Account;
    this.toaster = toaster;
    this.Facebook = Facebook;
    this.YouTubeUser = YouTubeUser;
    this.TwitterUser = TwitterUser;
    this.RTMPPushChannel = RTMPPushChannel;
    this.VimeoUser = VimeoUser;
    this.Broadcast = Broadcast;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.FacebookUser = FacebookUser;
    this.$timeout = $timeout;
    this.$state = $state;
    this.canAddTwitterUsers = this.user.can('create', 'twitter-user');
    this.canAddAnyIntegration =
      this.user.can('create', 'facebook-user') ||
      this.user.can('create', 'youtube-user') ||
      this.user.can('create', 'twitter-user') ||
      this.user.can('create', 'vimeo-user') ||
      this.user.can('create', 'rtmp-push-channel');

    this.loadingPromises = [];
    this.expandCurrentFacebookUser = false;
    this.reload();
    this.fbInit();

    // Detect traits that can cause social media integration problems
    this.adBlockerEnabled = false;
    blockAdBlock.on(true, () => {
      $timeout(() => (this.adBlockerEnabled = true), 0);
    });
    blockAdBlock.check();
    this.usingFirefox = false;
    if (navigator.userAgent.indexOf('Firefox') >= 0) {
      this.usingFirefox = true;
    }
  }

  reload() {
    const {
      FacebookUser,
      YouTubeUser,
      toaster,
      TwitterUser,
      RTMPPushChannel,
      VimeoUser,
      Broadcast,
      $q,
      user,
    } = this;

    this.allAccounts = [];

    // Facebook
    if (user.can('list', 'facebook-users')) {
      this.loadingPromises.push(
        FacebookUser.query()
          .$promise.then((users) => {
            this.facebookAccounts = users;
            this.facebookAccounts.forEach((a) => (a.type = 'facebook'));
            this.allAccounts = this.allAccounts.concat(this.facebookAccounts);
            this.processFacebookLinkToCurrentUser();
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to load your linked Facebook accounts. Please reload this page and try again.'
            );
          })
      );
    }

    // YouTube
    if (user.can('list', 'youtube-users')) {
      this.loadingPromises.push(
        YouTubeUser.query()
          .$promise.then((users) => {
            this.youtubeUsers = users;
            this.youtubeUsers.forEach((u) => {
              u.type = 'youtube';
              u.__isYTLiveEnabled__ =
                _.reduce(
                  u.scope,
                  (c, s) => c + (s == 'https://www.googleapis.com/auth/youtube' ? 1 : 0),
                  0
                ) > 0;
            });
            this.allAccounts = this.allAccounts.concat(this.youtubeUsers);
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to load your linked YouTube accounts. Please reload this page and try again.'
            );
          })
      );
    }

    // Twitter
    if (user.can('list', 'twitter-users')) {
      this.loadingPromises.push(
        TwitterUser.query()
          .$promise.then((users) => {
            this.twitterUsers = users;
            this.twitterUsers.forEach((a) => (a.type = 'twitter'));
            this.allAccounts = this.allAccounts.concat(this.twitterUsers);
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to load your linked Twitter accounts. Please reload this page and try again.'
            );
          })
      );
    }

    // Vimeo
    if (user.can('list', 'vimeo-users')) {
      this.loadingPromises.push(
        VimeoUser.query()
          .$promise.then((users) => {
            this.vimeoUsers = users;
            this.vimeoUsers.forEach((a) => (a.type = 'vimeo'));
            this.allAccounts = this.allAccounts.concat(this.vimeoUsers);
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to load your linked Vimeo accounts. Please reload this page and try again.'
            );
          })
      );
    }

    // RTMP Push
    if (user.can('list', 'rtmp-push-channels')) {
      this.loadingPromises.push(
        RTMPPushChannel.query()
          .$promise.then((channels) => {
            this.rtmpPushChannels = channels;
            this.rtmpPushChannels.forEach((a) => (a.type = 'rtmp_push'));
            this.allAccounts = this.allAccounts.concat(this.rtmpPushChannels);
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to load your destinations. Please reload this page and try again.'
            );
          })
      );
    }

    // All Live Broadcasts ... to use to see which simulcast implementations are active,
    // so we need to get each live one in *show* scope, not *list* scope
    this.loadingPromises.push(
      $q((resolve, reject) => {
        Broadcast.query(
          { q: 'timeframe:current', l: 100 },
          (broadcasts) => {
            $q.all(
              broadcasts.map((b) => {
                var broadcast = Broadcast.get({ id: b.id });
                return broadcast.$promise;
              })
            )
              .then((broadcasts) => {
                this.broadcasts = broadcasts;
                resolve(broadcasts);
              })
              .catch((err) => {
                reject(err);
              });
          },
          (err) => reject(err)
        );
      })
    );

    // Sportzcast configuration is modeled as an integration
    if (this.FeatureFlags.sportzcast && this.user.can('read', 'sportzcast-configuration')) {
      this.sportzcast = this.Account.getSportzcast(() => {
        // Work with <integration-row> components
        this.sportzcast.type = 'sportzcast';
        this.sportzcast.hideStatusDot = true;
        this.sportzcast.display_name = `ScoreBOT`;
        this.sportzcast.display_subtitle = `Username ${this.sportzcast.username}`;
      });
      this.loadingPromises.push(this.sportzcast.$promise);
    }

    // Once everything is done loading, match up the live broadcast configurations with the
    // linked social accounts;
    $q.all(this.loadingPromises).then(() => {
      this.allAccounts.forEach((a) => {
        // Normalize display_name across various configuration types
        a.display_name = a.display_name || a.fb_user_name || a.name;
      });

      this.broadcasts.forEach((b) => {
        b.simulcast_configurations.forEach((c) => {
          if (c.destination == 'facebook') {
            this.facebookAccounts.forEach((a) => {
              if (a.id == c.facebook_account_id) {
                a.details = a.details || [];
                a.details.push(b);
              }
            });
          } else if (c.destination == 'youtube') {
            this.youtubeUsers.forEach((a) => {
              if (a.id == c.youtube_account_id) {
                a.details = a.details || [];
                a.details.push(b);
              }
            });
          } else if (c.destination == 'twitter') {
            this.twitterUsers.forEach((a) => {
              if (a.id == c.twitter_account_id) {
                a.details = a.details || [];
                a.details.push(b);
              }
            });
          } else if (c.destination == 'rtmp_push_channel') {
            this.rtmpPushChannels.forEach((a) => {
              if (a.id == c.rtmp_push_channel_id) {
                a.details = a.details || [];
                a.details.push(b);
              }
            });
          }
        });
      });

      this.allAccounts = _.sortBy(this.allAccounts, (a) => {
        var hasActivePrefix = a.details && a.details.length ? '0' : '1';
        return `${hasActivePrefix}-${a.display_name}-${a.type}`;
      });

      const integrationID = this.$state.params.integration_id;
      if (integrationID) {
        let scrollToID;
        for (let a of this.allAccounts) {
          if (a.id == integrationID) {
            a.__showDetails = true;
            scrollToID = `#${a.type}-${a.id}`;
            break;
          }
        }
        if (scrollToID) {
          this.$timeout(() => {
            $('html, body').animate({ scrollTop: $(scrollToID).offset().top - 100 });
          }, 10);
        }
      }
    });
  }

  processFacebookLinkToCurrentUser() {
    this.allAccounts.forEach((a) => {
      if (a.type == 'facebook' && this.Facebook.connected && this.Facebook.me.id === a.fb_user_id) {
        a.pages_managed = this.Facebook.accounts;
        if (this.expandCurrentFacebookUser) {
          a.__showDetails = true;
          this.$timeout(() => {
            $('html, body').animate({ scrollTop: $(`#${a.type}-${a.id}`).offset().top - 100 });
          }, 10);
        }
      } else {
        a.pages_managed = null;
      }
    });
  }

  showLinkModal() {
    const { $uibModal, Facebook, FeatureFlags, toaster, user } = this;

    const parentVM = this;

    $uibModal
      .open({
        template: require('./modal-add-integration.html'),
        controller: function ($uibModalInstance, $scope) {
          'ngInject';
          this.user = user;
          this.FeatureFlags = FeatureFlags;
          this.cancel = () => $uibModalInstance.dismiss('cancel');
          this.linkFacebook = () => {
            Facebook.login()
              .then(() => {
                $scope.$evalAsync(() => {
                  parentVM.expandCurrentFacebookUser = true;
                  parentVM.fbInit();
                  parentVM.reload();
                  this.cancel();
                });
              })
              .catch((err) => {
                toaster.pop('warning', 'Unable to link the Facebook account');
                remoteLogger.error('Error linking Facebook account', { error: err });
              });
          };
          this.addRtmp = () => {
            this.cancel();
            parentVM.onAddRtmp();
          };
        },
        controllerAs: 'vm',
      })
      .result.then((r) => {
        this.reload();
      });
  }

  onToggleDetails(a) {
    if (a.__showDetails) {
      a.__showDetails = false;
    } else {
      a.__showDetails = true;
    }
  }

  onDeleteLink(a) {
    const { Facebook, FacebookUser, toaster, YouTubeUser, VimeoUser, TwitterUser } = this;

    if (a.type == 'facebook') {
      if (
        !confirm(
          'Are you sure you want to unlink the account? Any future events linked to this account will not stream to Facebook.'
        )
      ) {
        return false;
      }
      const deleteLinkedAccount = () => {
        FacebookUser.delete({ id: a.id })
          .$promise.then(() => {
            toaster.pop('success', 'Deleted linked Facebook account.');
            this.reload();
          })
          .catch((err) => {
            console.error(err);
            toaster.pop(
              'warning',
              'Unable to delete your linked Facebook account. Please reload this page and try again.'
            );
          });
      };
      if (Facebook.connected && Facebook.me.id == a.fb_user_id) {
        Facebook.logout().then(deleteLinkedAccount);
      } else {
        deleteLinkedAccount();
      }
    }

    if (a.type == 'youtube') {
      if (
        !confirm(
          'Are you sure you want to unlink the account? Any future events linked to this account will not stream to YouTube.'
        )
      ) {
        return false;
      }
      YouTubeUser.delete(
        { id: a.id },
        () => {
          toaster.pop('success', 'Deleted linked YouTube account.');
          this.reload();
        },
        (err) => {
          console.error(err);
          toaster.pop(
            'warning',
            'Unable to delete your linked YouTube account. Please reload this page and try again.'
          );
        }
      );
    }

    if (a.type == 'twitter') {
      if (!confirm('Are you sure you want to unlink the account?')) {
        return false;
      }
      TwitterUser.delete(
        { id: a.id },
        () => {
          toaster.pop('success', 'Deleted linked Twitter account.');
          this.reload();
        },
        (err) => {
          console.error(err);
          toaster.pop(
            'warning',
            'Unable to delete your linked Twitter account. Please reload this page and try again.'
          );
        }
      );
    }

    if (a.type == 'vimeo') {
      if (!confirm('Are you sure you want to unlink the account?')) {
        return false;
      }
      VimeoUser.delete(
        { id: a.id },
        () => {
          toaster.pop('success', 'Deleted linked Vimeo account.');
          this.reload();
        },
        (err) => {
          console.error(err);
          toaster.pop(
            'warning',
            'Unable to delete your linked Vimeo account. Please reload this page and try again.'
          );
        }
      );
    }
  }

  onDeleteRtmp(a) {
    const { RTMPPushChannel, toaster } = this;
    if (
      !confirm(
        'Are you sure you want to delete this destination? This will also unlink it from any broadcasts that use it.'
      )
    ) {
      return false;
    }
    RTMPPushChannel.delete(
      { id: a.id },
      () => {
        toaster.pop('success', 'Deleted destination.');
        this.reload();
      },
      (err) => {
        console.error(err);
        toaster.pop(
          'warning',
          'Unable to delete your destination. Please reload this page and try again.'
        );
      }
    );
  }

  onRelink(a) {
    const { $scope, $state, Facebook } = this;
    if (a.type == 'facebook') {
      Facebook.login().then(() => {
        $scope.$evalAsync(() => {
          this.expandCurrentFacebookUser = true;
          this.fbInit();
          this.reload();
        });
      });
    } else {
      $state.go(`settings.${a.type}`, { link: 1 });
    }
  }

  onEditSportzcast() {
    const { $uibModal, Account } = this;

    $uibModal
      .open({
        template: require('./modal-edit-sportzcast.html'),
        controller: require('./modal-edit-sportzcast').default,
        controllerAs: 'vm',
        resolve: {
          sportzcast: () => this.sportzcast,
        },
      })
      .result.then((r) => {
        this.reload();
      });
  }

  onEditRtmp(a) {
    const { $uibModal, RTMPPushChannel } = this;

    $uibModal
      .open({
        template: require('./modal-add-multi-use-rtmp-channel.html'),
        controller: require('./modal-add-multi-use-rtmp-channel').default,
        controllerAs: 'vm',
        resolve: {
          mode: () => 'edit',
          config: () => a,
        },
      })
      .result.then((r) => {
        this.reload();
      });
  }

  onAddRtmp() {
    const { $uibModal, RTMPPushChannel } = this;

    $uibModal
      .open({
        controllerAs: 'vm',
        template: require('./modal-add-multi-use-rtmp-channel.html'),
        controller: require('./modal-add-multi-use-rtmp-channel').default,
        controllerAs: 'vm',
        resolve: {
          mode: () => 'add',
          config: () => ({ max_resolution: 0 }),
        },
      })
      .result.then((r) => {
        this.reload();
      });
  }

  logoutFacebook() {
    this.Facebook.logout().then(() => this.reload());
  }

  fbInit() {
    this.Facebook.init()
      .then(() => {
        if (this.expandCurrentFacebookUser) {
          return this.Facebook.loadStatus({ force: true });
        }
      })
      .then(() => {
        this.$timeout(() => {
          this.processFacebookLinkToCurrentUser();
        }, 50); //wait 50ms because Facebook.accounts doesn't appear to be there in some cases
      })
      .catch((e) => {
        remoteLogger.error('Error initializing Facebook API', { error: e });
        this.toaster.pop('warning', 'Error initializing Facebook API');
      });
  }
}

export default IntegrationsController;



// WEBPACK FOOTER //
// ./app/pages/settings/integrations.js